import { PropertyPageQuery } from 'gql/graphql'
import AvailabilityForm from 'components/property/AvailabilityForm'
import BookingConditionsItem from './Item'
import Headers from 'components/home/common/typography/Headers'

const BookingConditionsSection = ({
  property,
}: {
  property: PropertyPageQuery['property']
}) => {
  return (
    <div className="flex flex-col items-center justify-between lg:flex-row gap-x-10">
      <div className="w-full max-w-[649px] flex flex-col lg:justify-between gap-y-18">
        <BookingConditionsItem
          title="Payment & Cancellations"
          content={
            <>
              To finalize your booking, you must pay a deposit corresponding to 50% of the rent.
              Deposit payment must be made within 48 hours of accepting the rental agreement.
              The balance of rental and damage deposit must be paid no later than {property?.property_rental_due?.value} days prior to arrival date. Payments can be made via bank transfer or credit card. All payments are non-refundable.
            </>
          }
        />

        {
          (property?.house_rules ?? []).length
            ? (
              <BookingConditionsItem
                title="House Rules"
                content={
                  <ul>
                    {(property?.house_rules ?? []).map((rule, index) => (
                      <li key={`${rule.id}-${index}`}>
                        {rule.value}
                      </li>
                    ))}

                    {
                      property?.additional_house_rules && (
                        <li className="whitespace-pre-line">
                          {property?.additional_house_rules.replace(/^\s*[\r\n]/gm, '\n')}
                        </li>
                      )
                    }
                  </ul>
                }
              />
            )
            : null
        }

        <BookingConditionsItem
          title="Additional Information"
          content={[
            <ul className="flex flex-col leading-23">
              {
                property?.owner?.user_type_partner?.local_taxes_fees
                  ? (
                    <li className="whitespace-pre-line">
                      {`There is a ${property.owner?.user_type_partner?.local_taxes_fees}% tax and service fee to be added to the rental price.`}
                    </li>
                  )
                  : null
              }
              {(property?.additional_costs ?? []).map((cost, index) => (
                <li
                  key={`${cost.id}-${index}`}
                  className="whitespace-pre-line"
                >
                  {cost.value} charged at an additional cost
                </li>
              ))}
              {
                property?.extra_additional_costs
                  ? (
                    <li className="whitespace-pre-line">
                      {property?.extra_additional_costs.replace(/^\s*[\r\n]/gm, '\n')}
                    </li>
                  )
                  : null
              }
            </ul>,
            <span className="mt-10 italic">
              House rules and booking conditions are subject to change. Final terms and conditions will be confirmed upon reservation.
            </span>,
          ]}
        />
      </div>

      <div className="flex-col max-w-[430px] lg:max-w-[490px] w-full items-center lg:pt-40 border-0 lg:border border-grey-250 lg:px-30 mt-40 lg:mt-0 hidden lg:block">
        <Headers.XXL Tag="h4" className="text-center px-30 text-grey-900 mb-30">
          Request to Book
        </Headers.XXL>

        <AvailabilityForm property={property} className="py-40" />
      </div>
    </div>
  )
}
export default BookingConditionsSection
